import { SidebarItem } from "@backstage/core-components";
import { configApiRef, useApi } from "@backstage/core-plugin-api";
import { scorecardsEnabled } from "../config";
import { NAV } from "../nav";

/**
 * Sidebar link to the Scorecards page for the legacy sidebar; renders nothing
 * when `frontDoor.scorecards.enabled` is false.
 */
export const ScorecardsSidebarItem = () => {
  const config = useApi(configApiRef);
  if (!scorecardsEnabled(config)) return null;
  const { icon, path, title } = NAV.scorecards;
  return <SidebarItem icon={icon} to={path} text={title} />;
};
